// extracted by mini-css-extract-plugin
export var divider = "_tk-0";